<template>
  <div class="table">
    <table class="table table-sm horizon" ref="table">
      <tbody>
        <tr>
          <th>총 차량대수</th>
          <th>총 영업시간</th>
          <th>총 미터금액</th>
          <th v-if="isShowHipassFare">총 통행요금</th>
          <th>총 호출요금</th>
          <th>총 운행기사</th>
          <th>총 영업거리</th>
          <th v-if="isShowAddFare">총 추가금액</th>
          <th v-if="isShowTotalFare">총 합계금액</th>
        </tr>
        <tr>
          <td>{{ elements.allCarCount ? insertComma(elements.allCarCount) : elements.allCarCount }}대</td>
          <td>{{ elements.allWorkTime}}</td>
          <td>{{ elements.allPayFare ? insertComma(elements.allPayFare ) : elements.allPayFare }}원</td>
          <td v-if="isShowHipassFare">{{ elements.allHipassFare ? insertComma(elements.allHipassFare) : elements.allHipassFare}}원</td>
          <td>{{ elements.allCallFare ? insertComma(elements.allCallFare ) : elements.allCallFare }}원</td>
          <td>{{ elements.allDriverCount ? insertComma(elements.allDriverCount) : elements.allDriverCount }}명</td>
          <td>{{ elements.allWorkDist ? insertComma(elements.allWorkDist) : elements.allWorkDist }}Km</td>
          <td v-if="isShowAddFare">{{ elements.allAddFare ? insertComma(elements.allAddFare) : elements.allAddFare}}원</td>
          <td v-if="isShowTotalFare">{{ elements.allFare ? insertComma(elements.allFare) : elements.allFare}}원</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { defineProps, ref, defineExpose } from "vue";
import { insertComma } from "@/components/tacho/common/CommonFunc"

const props = defineProps({
  elements: Object,
  selectAutoScroll: Function,
  onSelected: Function,
  onDoubleClick: Function
})

const scroll = ref("");

const autoScroll = () => (props.selectAutoScroll !== undefined && scroll.value.scrollHeight - scroll.value.scrollTop <= scroll.value.clientHeight) ? props.selectAutoScroll() : "";

const isShowHipassFare = ref(true)
const isShowAddFare = ref(true)
const isShowTotalFare = ref(true)
const isShowRenewalTime = ref(true)

defineExpose({
  isShowHipassFare, isShowAddFare, isShowTotalFare, isShowRenewalTime
})

</script>

<style scoped>
* {
  font-size: 0.8rem; 
}
</style>
